import {
  Add_City,
  Delete_One_City_data,
  Get_All_Cities,
  Get_Error,
  Get_One_City_Data,
  Update_One_City_data,
} from '../Types';

const intial = {
  city: [],

  loading: true,
};

const city_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Cities:
      return {
        ...state,
        city: action.payload,
        loading: false,
      };
    case Add_City:
      return {
        city: action.payload,
        loading: false,
      };
    case Get_One_City_Data:
      return {
        city: action.payload,
        loading: false,
      };
    case Update_One_City_data:
      return {
        city: action.payload,
        loading: false,
      };
    case Delete_One_City_data:
      return {
        city: action.payload,
        loading: false,
      };
    case Get_Error:
      return {
        loading: true,
        city: action.payload,
      };
    default:
      return state;
  }
};

export default city_Reducer;
